import React from 'react';

import './StepCardListStyle.less';

interface IStepCardProps {
  index: number;
  title: string;
}

interface IStepCard {
  title: string;
  content: string;
}

interface IStepCardListProps {
  steps: IStepCard[];
}

const StepCard: React.SFC<IStepCardProps> = props => (
  <div className="od-step-card">
    <h6 className="prose">
      <span className="od-step-card__title-index text-blue">{props.index}</span>
      {props.title}
    </h6>
    {props.children}
  </div>
);

export const StepCardList: React.SFC<IStepCardListProps> = props => (
  <div className="od-step-card-list prose">
    {props.steps.map((step, index) => (
      <StepCard index={index + 1} key={index + 1} title={step.title}>
        {step.content}
      </StepCard>
    ))}
  </div>
);

export default StepCardList;
